import cwbtw from './cwbtw'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  index ({ state, commit, rootState }, params) {
    return rootState.axios.get('/calendar/v1frontend/calendar/index', { params })
  },
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/calendar/v1frontend/calendar/search', { params })
  },
  searchSchedules ({ state, commit, rootState }, params) {
    return rootState.axios.get('/calendar/v1frontend/calendar/search-schedules', { params })
  },
  searchLastJycut ({ state, commit, rootState }, params) {
    return rootState.axios.get('/calendar/v1frontend/calendar/search-last-jycut', { params })
  },
  searchSrun ({ state, commit, rootState }, params) {
    return rootState.axios.get('/calendar/v1frontend/calendar/search-srun', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    cwbtw,
  }
}
